// apps/prompts/src/components/ErrorFallbacks.tsx
import {
  GlassPanel,
  Button,
  AppIcon,
  IconBolt,
  IconPackage,
  IconTools,
  IconArrowLeft,
} from '@neuroforge/ui'
import { Link } from 'react-router'

// ─── Prompt-specific error ───
export function PromptErrorFallback({ error, onReset }: { error: Error; onReset: () => void }) {
  return (
    <div className="py-12">
      <GlassPanel className="mx-auto max-w-lg p-10 text-center">
        <AppIcon
          icon={IconBolt}
          size={28}
          className="mx-auto mb-3 h-10 w-10 text-amber-500"
          aria-hidden
        />
        <h2 className="mb-2 text-lg font-extrabold tracking-tight">Prompt introuvable ou erreur</h2>
        <p className="mb-6 text-sm text-slate-500">
          {error.message || "Ce prompt n'a pas pu être chargé."}
        </p>
        <div className="flex justify-center gap-3">
          <Button onClick={onReset}>Réessayer</Button>
          <Link to="/browse">
            <Button variant="secondary">
              <span className="inline-flex items-center gap-1.5">
                <AppIcon icon={IconArrowLeft} size={16} aria-hidden /> Explorer
              </span>
            </Button>
          </Link>
        </div>
      </GlassPanel>
    </div>
  )
}

// ─── Collection-specific error ───
export function CollectionErrorFallback({ error, onReset }: { error: Error; onReset: () => void }) {
  return (
    <div className="py-12">
      <GlassPanel className="mx-auto max-w-lg p-10 text-center">
        <AppIcon
          icon={IconPackage}
          size={28}
          className="mx-auto mb-3 h-10 w-10 text-violet-500"
          aria-hidden
        />
        <h2 className="mb-2 text-lg font-extrabold tracking-tight">Collection introuvable</h2>
        <p className="mb-6 text-sm text-slate-500">
          {error.message || "Cette collection n'a pas pu être chargée."}
        </p>
        <div className="flex justify-center gap-3">
          <Button onClick={onReset}>Réessayer</Button>
          <Link to="/collections">
            <Button variant="secondary">
              <span className="inline-flex items-center gap-1.5">
                <AppIcon icon={IconArrowLeft} size={16} aria-hidden /> Collections
              </span>
            </Button>
          </Link>
        </div>
      </GlassPanel>
    </div>
  )
}

// ─── Generic page error ───
export function PageErrorFallback({ error, onReset }: { error: Error; onReset: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <AppIcon
        icon={IconTools}
        size={28}
        className="mx-auto mb-4 h-12 w-12 text-slate-500"
        aria-hidden
      />
      <h2 className="mb-2 text-xl font-extrabold tracking-tight">Oups, quelque chose a cassé</h2>
      <p className="mb-6 max-w-md text-sm text-slate-500">
        {error.message || 'Une erreur inattendue est survenue.'}
      </p>
      <div className="flex gap-3">
        <Button onClick={onReset}>Réessayer</Button>
        <Link to="/">
          <Button variant="secondary">
            <span className="inline-flex items-center gap-1.5">
              <AppIcon icon={IconArrowLeft} size={16} aria-hidden /> Accueil
            </span>
          </Button>
        </Link>
      </div>
    </div>
  )
}
